import { Injectable } from '@angular/core';
import { CampaignService } from '../campaign.service';

/* RxJs */
import { Observable, of } from 'rxjs';
import { mergeMap, map, catchError } from 'rxjs/operators';

/* NgRx */
import * as tabPendingApprovalCampaignActions from './tab-pending-approval-campaign.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';

@Injectable()
export class TabPendingApprovalCampaignEffects {
    constructor(private _campaignService: CampaignService,
        private _actions$: Actions) { }

    @Effect()
    loadPendingApprovalCampaignSummaries$: Observable<Action> = this._actions$.pipe(
        ofType(tabPendingApprovalCampaignActions.TabPendingApprovalCampaignActionTypes.loadCampaigns),
        map((action: tabPendingApprovalCampaignActions.LoadCampaigns) => action.payload),
        mergeMap((requestInfo) =>
            this._campaignService.getPendingCampaigns(requestInfo.pagination.index,
                requestInfo.pagination.size, requestInfo.sorting.fieldName, requestInfo.sorting.direction).pipe(
                map(campaigns => (new tabPendingApprovalCampaignActions.LoadCampaignsSuccess(campaigns))),
                catchError(() => of(new tabPendingApprovalCampaignActions.LoadCampaignsFail('Error loading campaigns pending approval')))
            )
        )
    );
}
